<template>
  <VMenu v-model="menuOpen" :close-on-click="true" bottom offset-y content-class="elevation-2 layouts-menu-content">
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <BaseButton small color="orange lighten-2" v-on="on">
          {{ title }}
        </BaseButton>
      </slot>
    </template>

    <VList :class="colorClass">
      <WithAllLayouts v-slot="{ allLayouts, layoutsLoading, layoutsError }" type="digital">
        <div v-if="layoutsLoading" class="pa-3 text-xs-center">
          <VProgressCircular indeterminate size="20" width="2" />
        </div>
        <div v-else-if="allLayouts && allLayouts.length" class="all-layouts-dropdown">
          <div v-for="(group, i) in allLayouts" :key="group.locationSlug">
            <VSubheader class="founders-grotesk--font font-weight-bold">
              {{ group.locationTitle }}
            </VSubheader>
            <VListTile
              v-for="layout in group.layouts"
              :key="layout.id"
              :to="layout.slug !== currentLayoutSlug ? { path: `/locations/${group.locationSlug}/layouts/${layout.slug}`, query } : undefined"
              :disabled="layout.slug === currentLayoutSlug"
              :class="['ml-4', { 'layout--active': layout.slug === currentLayoutSlug }]"
            >
              <VListTileTitle class="caption">
                {{ layout.title }}
              </VListTileTitle>
            </VListTile>
            <VListTile
              v-if="!group.layouts.length"
              class="ml-4"
              disabled
            >
              <VListTileTitle class="caption grey--text">
                No digital layouts
              </VListTileTitle>
            </VListTile>
            <VDivider v-if="i < allLayouts.length - 1" />
          </div>
        </div>
        <div v-else-if="layoutsError">
          <VListTile disabled>
            <VListTileTitle class="caption grey--text">
              Failed to load layouts
            </VListTileTitle>
          </VListTile>
        </div>
        <div v-else>
          <VListTile disabled>
            <VListTileTitle class="caption grey--text">
              No locations available
            </VListTileTitle>
          </VListTile>
        </div>
      </WithAllLayouts>
    </VList>
  </VMenu>
</template>

<script>
import WithAllLayouts from '@dataProviders/WithAllLayouts'

export default {
  name: 'BaseAllLayoutsMenu',
  components: {
    WithAllLayouts,
  },
  props: {
    title: {
      type: String,
      default: 'View Other Layouts',
    },
    colorClass: {
      type: String,
      default: '',
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    currentLayoutSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menuOpen: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.all-layouts-dropdown {
  min-width: 250px;
}
</style>

<style scoped>
.layout--active .v-list__tile__title {
  font-weight: 900;
}
.layout--active {
  background: rgba(0, 0, 0, 0.06);
}
</style>

<style>
.layouts-menu-content {
  z-index: 999 !important;
}
</style>
